/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Design Sizes popup */
(function(){
  var body = document.querySelector('body');
  var button = document.getElementById('design-sizes-button');
  var wrapper = document.getElementById('design-sizes-wrapper');
  var close = document.getElementById('design-sizes-close');
  function show(){
    body.classList.add('show-design-sizes');
  }
  function hide(){
    body.classList.remove('show-design-sizes');
  }
  if(button && wrapper){
    body.appendChild(wrapper);
    button.addEventListener('click', show);
    button.addEventListener('touchstart', show);
    close.addEventListener('click', hide);
    close.addEventListener('touchstart', hide);
    wrapper.addEventListener('click', hide);
    wrapper.addEventListener('touchstart', hide);
  }
})();
$(document).ready(function () {
  $('body').on('click','.close_reorder_popup', function(e) {
    e.preventDefault();
    var modal = $(this).closest('.reorder_popup');
    modal.removeClass('active');
  });
  
  
  $('body').on('click','.purchase_again_btn', function(e) {
    e.preventDefault();
    var modal = $(this).closest('.reorder_popup');
    var dataId = modal.attr('data-id') * 1;
    var productId= modal.attr('data-productId');
    var qty = $('#product_form_'+productId).find('.quantity-selector__value').val() * 1;
   
    modal.removeClass('active');

    var formData = {
      'items': [{
        'id': dataId,
        'quantity': qty
      }]
    };

    fetch("".concat(window.routes.cartAddUrl, ".js"), {
      body: JSON.stringify(formData),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));

      if (response.ok) {
        modal.removeClass('active');

        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            quantity: qty
          }
        }));

      } else {
        response.json().then(function (content) {
          alert(content['description']);
        });
      }
    });



  });;
});

document.addEventListener('variant:changed', function(event) {
 var variant = event.detail.variant; // Gives you access to the whole variant details
 var reorder_popup = $(".reorder_popup"); 
 reorder_popup.attr("data-id", variant.id);

});